/**
 * NativeWelcome — what /welcome renders on native instead of Landing.jsx.
 *
 * Landing.jsx is the full marketing page: a sticky nav, a hero with a fake
 * composer animation, five more sections and a footer. That's the right page
 * for someone who followed an ad link into a browser tab — but rendered
 * inside a WKWebView it reads exactly like what it is: a website, not an
 * app. That is precisely the "repackaged website" signal Guideline 4.2 is
 * looking for on the very first screen a reviewer sees.
 *
 * This is the compact alternative: mascot, one line of positioning, the two
 * real actions (create an account or sign in). No pricing (Guideline
 * 3.1.1 — see runtime.js), no marketing nav, no scroll-jacked sections.
 * Terms/Privacy are deliberately not repeated here — requested directly, and
 * both are already reachable post-login under Settings → Privacy
 * (PrivacySection.jsx links /terms and /privacy), so nothing is stranded.
 *
 * Web is untouched — Landing.jsx still renders there. See App.jsx.
 */

import { useNavigate } from 'react-router-dom'
import { JAI_COLORS, JAI_FONTS } from '../components/JaiBrand'
import { JAIMascot } from '../components/JAIMascot'

export default function NativeWelcome() {
  const navigate = useNavigate()

  return (
    <div
      style={{
        minHeight: 'calc(100vh / var(--jai-zoom))',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 28,
        padding: '24px 28px',
        paddingTop: 'calc(var(--safe-top) + 24px)',
        paddingBottom: 'calc(var(--safe-bottom) + 24px)',
        background: `linear-gradient(180deg, ${JAI_COLORS.navyDeep} 0%, ${JAI_COLORS.navy} 100%)`,
        textAlign: 'center',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
        <div style={{ fontFamily: JAI_FONTS.tight, fontWeight: 800, fontSize: 26, letterSpacing: '-0.035em', color: 'white' }}>
          Welcome to JAI
        </div>
        <JAIMascot size={104} state="happy" animate={true} />
        {/* Short and sport-neutral — "AI co-manager" language lives in the
            longer web pitch; this is the one line a reviewer reads before
            tapping past this screen. */}
        <p style={{
          fontFamily: JAI_FONTS.tight, fontSize: 16, fontWeight: 600, lineHeight: 1.4,
          color: 'rgba(246,248,251,0.85)', maxWidth: 300, margin: 0,
        }}>
          Your Fantasy Sports Co-Manager
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%', maxWidth: 320 }}>
        <button
          onClick={() => navigate('/signup')}
          style={{
            fontFamily: JAI_FONTS.tight, fontSize: 16, fontWeight: 700,
            color: JAI_COLORS.navyDeep, background: 'white',
            border: 'none', borderRadius: 999, padding: '15px 20px',
            cursor: 'pointer', minHeight: 44,
          }}
        >
          Create your free account
        </button>
        <button
          onClick={() => navigate('/login')}
          style={{
            fontFamily: JAI_FONTS.tight, fontSize: 16, fontWeight: 700,
            color: 'white', background: 'rgba(255,255,255,0.08)',
            border: '1px solid rgba(255,255,255,0.18)', borderRadius: 999,
            padding: '15px 20px', cursor: 'pointer', minHeight: 44,
          }}
        >
          Sign in
        </button>
      </div>
    </div>
  )
}
